import React from 'react';
import css from './AutographFormFields.module.css';
import { FormattedMessage } from 'react-intl';
import { Field } from 'react-final-form';
import { FieldCheckbox } from '../../../../components';
const SelectedPhotosField = ({ photoOptions = [], formId, values }) => {
  return (
    <div className={css.fieldGroup}>
      <Field name="selectedPhotos" type="checkbox">
        {({ input }) => {
          const selectedValues = input.value || [];

          return (
            <div className={css.fieldGroup}>
              <label className={css.label}>
                <FormattedMessage id="AutographFormFields.selectPhotos" />
              </label>

              <Field name="selectedPhotos">
                {({ input, meta }) => {
                  // Ensure we always have an array (react-final-form sometimes gives undefined)
                  const selectedValues = Array.isArray(input.value) ? input.value : [];

                  return (
                    <>
                      <div className={css.photoGrid}>
                        {photoOptions.map(photo => {
                          const isChecked = selectedValues.includes(photo.id);

                          return (
                            <label
                              key={photo.id}
                              className={`${css.photoOption} ${isChecked ? css.checked : ''}`}
                            >
                              <FieldCheckbox
                                id={`photo-${photo.id}`}
                                name={input.name}
                                value={photo.id}
                                checked={isChecked}
                                // Manual change handler for array values (required for checkboxes)
                                onChange={e => {
                                  if (e.target.checked) {
                                    input.onChange([...selectedValues, photo.id]);
                                  } else {
                                    input.onChange(selectedValues.filter(id => id !== photo.id));
                                  }
                                }}
                              />

                              <div className={css.photoPreview}>
                                <img
                                  src={photo.url}
                                  alt={photo.name}
                                  className={css.previewImage}
                                  loading="lazy"
                                />
                                <div className={css.photoInfo}>
                                  <span className={css.photoName}>{photo.name}</span>
                                  {/* Optional: Show origin (e.g. "From: Guitar" or "From Post: Coffee") */}
                                  {photo.originalItemTitle && (
                                    <span className={css.photoSource}>
                                      From: {photo.originalItemTitle}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </label>
                          );
                        })}
                      </div>

                      {/* Error message if none selected */}
                      {meta.touched && meta.error && <p className={css.error}>{meta.error}</p>}
                      {meta.touched && selectedValues.length === 0 && (
                        <p className={css.error}>
                          <FormattedMessage id="AutographFormFields.noPhotosSelected" />
                        </p>
                      )}
                    </>
                  );
                }}
              </Field>
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default SelectedPhotosField;
